import React from "react";
import {withChatContext} from "stream-chat-react";
import moment from "moment";
import User from "./User";

import styles from "../styles/general.module.scss";
import userStyles from "../styles/user.module.scss";

import {allHelpRoles} from "../local_roles";

const SupportChannelPreview = ({channel, title, unread, onClick}) => {
    const blink = unread ? styles.blink : '';

    return (
        <div className={`${styles.channel} ${styles.helpChannel} ${blink} list-group-item`}>
            <a href="" id={`channel-${channel.id}`} onClick={onClick}>
                <div className={styles.info}>
                    <div className={styles.name}>
                        {title}
                    </div>
                </div>
            </a>
        </div>
    );
};

class CustomChannelPreview extends React.Component {

    onChannelClick = (ev) => {
        const {setActiveChannel, channel} = this.props;
        ev.preventDefault();
        setActiveChannel(channel);
    };

    render() {
        const {channel, latestMessage, unread, client} = this.props;
        const isSupportUser = allHelpRoles.includes(client.user.local_role);
        const memberLookup = m => {
            if (isSupportUser) {return m.role === 'owner'}
            else {return m.user.id !== client.user.id;}
        };
        const member = Object.values(channel.state.members).find(memberLookup);

        if(!member) return null;

        if (channel.id === `${client.user.id}-qa`) {
            return (
                <SupportChannelPreview
                    channel={channel}
                    title="Enter your Q&A here !"
                    latestMessage={latestMessage}
                    unread={unread}
                    onClick={this.onChannelClick}
                />
            );
        } else if (channel.id === `${client.user.id}-help`) {
            return (
                <SupportChannelPreview
                    channel={channel}
                    title="Need some help?"
                    latestMessage={latestMessage}
                    unread={unread}
                    onClick={this.onChannelClick}
                />
            );
        }

        return null;
    }
};

export default withChatContext(CustomChannelPreview);